<span class="cursor-pointer text-shui-text-subtle flex items-center gap-2" id="navbar-language-selector">
    <sh-icon icon="region-language" size="s" class="text-shui-text-subtle"></sh-icon>
    {{ currentLang().toUpperCase() }}
</span>
<sh-popover target="navbar-language-selector" position="bottom">
    @for (language of supportedLanguages; track language) {
        <sh-menu-item
            label="{{ 'language.' + language | translate }}"
            [active]="currentLang() === language"
            (click)="changeLanguage(language)"
            ><img slot="functions" class="w-5 h-5 rounded-sm" [src]="flagMap[language]" alt="{{ language }} Flag"
        /></sh-menu-item>
    }
</sh-popover>
